import React from 'react';
import { connect } from 'react-redux'
import actions from '../../redux/actions'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Layout from '../../components/Layout'
import ProgressBar from '../../components/ProgressBar'
import ButtonComponent from '../../components/Button';
import { Form, Input, Icon } from 'antd';

import howtobookbank from '../../assets/images/howtobookbank.svg'

import constants from '../../config/constants'

const Main = styled.div`
  padding: 2rem 0 1.5rem;
  overflow-y: scroll;
  scroll-behavior: smooth;
`

const MainImg  = styled.div`
  text-align: center;
`

const MainDetail = styled.div`
  .ant-input {
    color: ${constants.color.dark} !important;
    border: 1px solid ${constants.color.lightDark} !important;
    line-height: 24.3px !important;
    height: 40px !important;
    font-size: 16px !important;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }

    &::placeholder {
      color: ${constants.color.lightDark} !important;
    }
  }

  .ant-form-item-required::before {
    content: '' !important;
    margin-right: 0 !important;
  }

  .ant-form-item-label > label {
    font-family: 'Thonburi';
    color: ${constants.color.mediumDark} !important;
  }

  .ant-form-item-control {

    .ant-form-extra {
      font-size: 12px !important;
    }
  }

  .has-error .ant-form-explain, .has-error .ant-form-split {
    color: ${constants.color.red} !important;
  }
`

const FormItem = styled(Form.Item)`
  margin-bottom: 2.5rem;
  margin-top: 1rem;

  input {
    height: 45px !important;
    font-size: 16px !important;
    border: 1px solid ${constants.color.lightDark} !important;
    width: 100%;
    padding: 4px 11px;
    border-radius: 8px;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }
  }
`

class HowToBookBank extends React.Component {

  componentDidMount = () => {
    this.props.form.setFieldsValue({
      'bank': this.props.userInfomations.bank,
      'bankAccountNumber': this.props.userInfomations.bankAccountNumber,
    })
  }

  handlebankAccountNumberChange = (e) => {
    this.props.setBankAccountNumber(e.target.value)
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err) => {
      if (!err) {
        // console.log(this.props.userInfomations)
        this.props.history.push('/camera-book-bank');
      }
    });
};

  render() {
    const formItemLayout = {
      labelCol: { span: 24 },
      wrapperCol: {span: 24 },
    };

    const { getFieldDecorator } = this.props.form;
    return (
      <Layout title={'สมุดบัญชีธนาคาร'} backIcon={true} onClick={() => this.props.history.goBack()}>
        <ProgressBar percent={50}/>
        <Main>
          <h5>สำหรับรับเงินขายคืนกองทุนกรณีเกินวงเงินในวอลเล็ท ใช้ได้เฉพาะบัญชีที่มีสมุดบัญชีเท่านั้น</h5>
          <MainDetail>
            <Form {...formItemLayout} hideRequiredMark={true}>
              <div>
              <Form {...formItemLayout}>
                <FormItem label="บัญชีธนาคาร">
                  {getFieldDecorator('bank', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาเลือกข้อมูล',
                      }
                    ],
                    })(<Input
                      placeholder="เลือกข้อมูล"
                      suffix={<Icon type="right"/>}
                      onClick={() => this.props.history.push('/select-bank')}
                    />)}
                </FormItem>
                <FormItem label={'เลขบัญชี'} extra="*ข้อมูลบนบัญชีธนาคารต้องชัดเจนไม่มีการปิดบังส่วนหนึ่งส่วนใดของหน้าหน้าบัญชี">
                  {getFieldDecorator('bankAccountNumber', {
                    rules: [
                      {
                        required: true,
                        message: 'กรุณาระบุ',
                      }
                    ],
                    })(<Input inputmode="numeric" placeholder="กรุณาระบุ" onChange={this.handlebankAccountNumberChange}/>)}
                </FormItem>
              </Form>
              </div>
            </Form>
          </MainDetail>
          <MainImg>
            <LazyLoadImage
              alt=''
              height={220}
              visibleByDefault={true}
              src={howtobookbank}
              width={'auto'} />
          </MainImg>
        </Main>
        <ButtonComponent
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ถ่ายรูป'}
          disabled={false}
          onClick={this.handleSubmit}/>
      </Layout>
    )
  }
}

const mapDispatchToProps = {
  setBankAccountNumber: actions.setBankAccountNumber,
}

const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const WrappedHowToBookBank = Form.create({ name: 'howToBookBank' })(HowToBookBank);

const HowToBookBankWithConnect = connect(mapStateToProps, mapDispatchToProps)(WrappedHowToBookBank)

export default HowToBookBankWithConnect
